import Vue from "vue"
import App from "./App.vue"

import "./registerServiceWorker"
import router from "./router"
import store from "./store"
import axios from "axios"
import settings from "@/api/settings"

let { apiSettings } = settings
axios.defaults.baseURL = apiSettings.url

import VueLazyload from "vue-lazyload"

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/images/icons/image-placeholder.svg",
  loading: "/images/icons/loading-solid.svg",
  attempt: 1,
  observer: true
})

Vue.config.productionTip = false

import Vuelidate from "vuelidate"

Vue.use(Vuelidate)

import Clipboard from "v-clipboard"

Vue.use(Clipboard)

import InlineSvg from "vue-inline-svg"
Vue.component("inline-svg", InlineSvg)

import VuePlyr from "vue-plyr"

// Vue 2.x
// The second argument is optional and sets the default config values for every player.
Vue.use(VuePlyr, {
  plyr: {}
})

import vClickOutside from "v-click-outside"

Vue.use(vClickOutside)

const mountApp = () => {
  new Vue({
    router,
    store,
    render: (h) => h(App)
  }).$mount("#app")
}

store.dispatch("INIT_APP").then(mountApp).catch(mountApp)

/* THIS IS THE FIRST AWESOME COMMENT FOR DOCUMENTATION */

/* THIS IS A SECONMD AWESOME COMMENT FOR DOCUMENTATION */

/* THIS IS A THIRD AWESOME COMMENT FOR DOCUMENTATION */
